// AUTO-GENERATED by scripts/gen-icons.mjs — do not edit by hand.
import Svg from '../svg/refresh.svg?react';
import { Icon } from '../Icon';
import { IconProps } from '../types';

export const RefreshIcon = (props: IconProps) => <Icon svg={Svg} {...props} />;
